import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 mt-24" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <img 
              src="/logo.png" 
              alt="Digital Power" 
              className="h-28 w-auto object-contain mb-4 brightness-110"
              data-testid="footer-logo"
            />
            <p className="text-sm">
              Your trusted partner for power backup and energy solutions.
            </p>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Products</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/products" className="hover:text-primary transition-colors">All Products</Link></li>
              <li><Link to="/products?category=Inverters" className="hover:text-primary transition-colors">Inverters</Link></li>
              <li><Link to="/products?category=Solar Panels" className="hover:text-primary transition-colors">Solar Panels</Link></li>
              <li><Link to="/products?category=Batteries" className="hover:text-primary transition-colors">Batteries</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-primary transition-colors">Installation</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Maintenance</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Repair</Link></li>
              <li><Link to="/services" className="hover:text-primary transition-colors">Consultation</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>Email: info@digital-power.in</li>
              <li>Phone: +91 9895677542</li>
              <li>Support: 24/7 Available</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-12 pt-8 text-center text-sm">
          <p>&copy; 2026 Digital Power Equipments. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
